import { render, staticRenderFns } from "./IviewTreeSelect.vue?vue&type=template&id=2476f8ea&scoped=true&"
import script from "./IviewTreeSelect.vue?vue&type=script&lang=js&"
export * from "./IviewTreeSelect.vue?vue&type=script&lang=js&"
import style0 from "./IviewTreeSelect.vue?vue&type=style&index=0&id=2476f8ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2476f8ea",
  null
  
)

export default component.exports